import { ofType } from 'redux-observable';
import { debounceTime, switchMap, map, catchError } from 'rxjs/operators';
import { from, of } from 'rxjs';
import {
  PAGINATE_RENTAL_INVENTORY_LIST_REQUEST,
  PAGINATE_RENTAL_INVENTORY_LIST_SUCCESS,
  EPIC_ERROR,
} from 'Constants/redux';
import service from 'Api/service';

const paginateRentalInventoryListEpic = (action$) =>
  action$.pipe(
    ofType(PAGINATE_RENTAL_INVENTORY_LIST_REQUEST),
    debounceTime(500),
    switchMap(({ params }) => {
      const {
        link,
        numberPer: per,
        status: filter,
        startDate,
        endDate,
        query,
      } = params;

      return from(
        service.get(`${import.meta.env.VITE_API_DOMAIN}${link}`, {
          per,
          filter,
          start_date: startDate,
          end_date: endDate,
          query,
        })
      ).pipe(
        map((response) => ({
          type: PAGINATE_RENTAL_INVENTORY_LIST_SUCCESS,
          payload: {
            rentalInventories: response.data.rentalInventories,
            pagination: response.data.meta.pagination,
          },
        })),
        catchError((err) => {
          console.error('paginateRentalInventoryListEpic error', err);
          return of({ type: EPIC_ERROR });
        })
      );
    })
  );

export default paginateRentalInventoryListEpic;
